// 5-stat grid shown on completed backtests: Trades / PnL / Fees / Max DD / Win Rate.
// Only rendered when status === "done" (values non-null).
import { fmt, pnlClass } from "@/lib/format";

interface Props {
  totalTrades: number;
  realizedPnl: number;
  totalFees: number;
  maxDrawdown: number;
  winRate: number; // decimal: 0.652 → 65.2%
}

function Stat({ label, value, valueClass }: { label: string; value: string; valueClass?: string }) {
  return (
    <div className="text-center">
      <div className="text-[0.65rem] uppercase tracking-wider text-muted mb-0.5">{label}</div>
      <div className={`text-sm font-semibold ${valueClass ?? "text-text"}`}>{value}</div>
    </div>
  );
}

export default function BacktestStats({ totalTrades, realizedPnl, totalFees, maxDrawdown, winRate }: Props) {
  return (
    <div className="grid grid-cols-5 gap-2 mt-3 pt-3 border-t border-border">
      <Stat label="Trades" value={String(totalTrades)} />
      <Stat label="PnL" value={fmt(realizedPnl, 4)} valueClass={pnlClass(realizedPnl)} />
      <Stat label="Fees" value={fmt(totalFees, 4)} />
      <Stat label="Max DD" value={fmt(maxDrawdown, 4)} valueClass="text-danger" />
      <Stat label="Win Rate" value={`${(winRate * 100).toFixed(1)}%`} />
    </div>
  );
}
